const VehicleHeaderCard = () => {
  const components = document.querySelectorAll('.js-heroVehicle');

  for (const component of components) {
    const triggers = [...component.querySelectorAll('.js-heroVehicle-pickerItem')];
    const images = [...component.querySelectorAll('.js-heroVehicle-image')];
    const nameNode = component.querySelector('.js-heroVehicle-colorName');

    let currentImage = images[0];
    let targetImage, oldCurrentImage;

    const handler = (e) => {
      const idx = triggers.indexOf(e.target);
      const colorName = e.target.dataset.name;

      targetImage = images[idx];

      if (currentImage && targetImage && currentImage !== targetImage) {
        for (const trigger of triggers) {
          if (trigger !== e.target) {
            trigger.classList.remove('-active');
          } else {
            trigger.classList.add('-active');
          }
        }

        for (const image of images) {
          if (image !== currentImage && image !== targetImage) {
            image.style.zIndex = 0;
          }
        }

        currentImage.style.zIndex = 1;
        targetImage.style.zIndex = 2;
        targetImage.classList.add('-active');
        currentImage.classList.remove('-active');
        oldCurrentImage = currentImage;
        currentImage = targetImage;
        nameNode.textContent = colorName;
      }
    };

    for (const trigger of triggers) {
      trigger.addEventListener('click', handler);
    }
  }
};

export default VehicleHeaderCard;
